/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-08 16:24:23
 */
import { getServerAndRole } from '@/api'

const user = {
  state: {
    serverName: window.sessionStorage.serverName,
    roleName: window.sessionStorage.roleName,
    roleId: window.sessionStorage.roleId, // 设置玩家编号，下一步选择角色
    appId: Number(window.sessionStorage.appId),
    appName: window.sessionStorage.appName,
    serverRoleList: [] // 用户区服对应角色
  },
  mutations: {
    SET_SERVER_NAME (state, serverName) {
      window.sessionStorage.serverName = serverName
      state.serverName = serverName
    },
    SET_ROLE_NAME (state, roleName) {
      window.sessionStorage.roleName = roleName
      state.roleName = roleName
    },
    SET_ROLE_Id (state, roleId) {
      window.sessionStorage.roleId = roleId
      state.roleId = roleId
    },
    SET_APP_ID (state, appId) {
      window.sessionStorage.appId = appId
      state.appId = appId
    },
    SET_APP_NAME (state, appName) {
      window.sessionStorage.appName = appName
      state.appName = appName
    },
    SET_SERVER_ROLE_LIST (state, serverRoleList) {
      state.serverRoleList = serverRoleList
    }
  },
  actions: {
    GetAllRoles ({ commit, state }, params) {
      if (state.serverRoleList.length > 0) {
        commit('SET_ROLE_Id', state.serverRoleList[0].service_id)
        return
      }
      return new Promise((resolve, reject) => {
        // resolve('vuex GetAllRoles')
        getServerAndRole(params).then(response => {
          const { code, data } = response
          if (code === 0) {
            commit('SET_SERVER_ROLE_LIST', data.server_list)
            commit('SET_ROLE_Id', data.server_list[0] ? data.server_list[0].service_id : '')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
